(
    function (skyward, $, undefined)
    {
        skyward.gradebooksettings = skyward.gradebooksettings || {};

        var init = function (selector)
        {
            $(selector + " #EditSectionGradeBucketDetails").on("DOVSaveValidationError", function ()
            {
                var browse = $("#EditSectionGradeBucketDetails").find(".editablebrowse:not(.hidden, .browse--displayNone)");

                if (!browse.hasClass('errorExpanded'))
                {
                    browse.addClass('errorExpanded');
                    browse.css('margin-top', '+=30px');
                }
            });

            $(selector + " #EditSectionGradeBucketDetails").on("change", ".js-CalcTypeComboBox", function ()
            {
                var calcTypeElement = $(this);
                changeCalculationType(calcTypeElement, "SectionGradeBucket");
            });

            $(selector + " #editCalculationGroupGradeBucket").on("change", ".js-CalcTypeComboBox", function ()
            {
                var calcTypeElement = $(this);
                changeCalculationType(calcTypeElement, "CalculationGroupGradeBucket");
            });

            $(selector + " #editCalculationGroupSubjectGradeBucket").on("change", ".js-CalcTypeComboBox", function ()
            {
                var calcTypeElement = $(this);
                changeCalculationType(calcTypeElement, "CalculationGroupSubjectGradeBucket");
            });

            $(selector + " #editCalculationGroupAcademicStandardGradeBucket").on("change", ".js-CalcTypeComboBox", function ()
            {
                var calcTypeElement = $(this);
                changeCalculationType(calcTypeElement, "CalculationGroupAcademicStandardGradeBucket");
            });

            $(selector + " .cumulativeAssignmentScoresExamWeightingBrowse").on("change", "input.checkbox", function ()
            {
                var checkbox = $(this);
                updateCumulativeAssignmentScoreWeightings(checkbox.parents(".browse").first());
            });

            $(selector + " .cumulativeAssignmentScoresExamWeightingBrowse").on("keyup", "input.cumulativeGradeWeightingPercent[data-type-code!='CU']", function ()
            {
                var input = $(this);
                var browse = input.parents(".browse").first();

                updateCumulativeAssignmentScoreWeightings(browse);
            });

            $(selector).find(".checkbox.academicStandardToDisplay").on("change", updateAcademicStandardsToDisplay);

            $(selector + " #EditSubjectsToDisplay, " + selector + " #EditAcademicStandardsToDisplay").on("change", ".subjectStandardDisplayCodeEelFilter", function ()
            {
                var codeEEL = $(this);
                var dov = codeEEL.parents(".dataObjectViewer").first();
                var calculationGroupGradeBucketID = skyward.controls.getValue(codeEEL);

                dov.find(".subjectsAcademicStandardsToDisplayContainer").addClass("displayNone");
                dov.find(".subjectsAcademicStandardsToDisplay-" + calculationGroupGradeBucketID).removeClass("displayNone");

                var isTeacherTracker = codeEEL.parent().data().teacherTracker == "true";
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/GradebookSettings/UpdateTeacherAccessSubjectStandardSelectedBucket" + (isTeacherTracker ? "TeacherTracker" : ""),
                    type: "POST",
                    data:
                    {
                        SelectedBucket: skyward.controls.getValue(codeEEL),
                        SectionLengthID: codeEEL.parent().data().sectionLengthId
                    }
                });
            });

            var displayGradingScaleLegend = function ()
            {
                var accessmode = $("#accessmode").val();
                var button = $(this);
                var buttonData = button.data();
                var action;

                var isStudentInformationPopup = button.data().isStudentInformationPopup;
                var objectLabel = "";

                if (buttonData && buttonData.objectLabel != null)
                {
                    objectLabel = buttonData.objectLabel.toString();
                    action = "StudentGradeBucket" + objectLabel + "GradingScale";
                    if (buttonData.isTeacherTracker.toString().toLowerCase() == "true")
                    {
                        action += "TeacherTracker";
                    }
                    else if (isStudentInformationPopup != null && isStudentInformationPopup.toString().toLowerCase() == "true")
                    {
                        action += "StudentInformationPopup" + buttonData.currentPortal.toString();
                    }
                }
                else
                {
                    if (buttonData.isTeacherTracker.toString().toLowerCase() == "true")
                    {
                        action = "GetGradingScaleBrowseTeacherTracker";
                    }
                    else if (isStudentInformationPopup != null && isStudentInformationPopup.toString().toLowerCase() == "true")
                    {
                        action = "GetGradingScaleBrowseStudentInformationPopup" + buttonData.currentPortal.toString();
                    }
                    else
                    {
                        action = "GetGradingScaleBrowse";
                    }
                }

                skyward.modalLayer.showDialog("Grading Scale", function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/ProgressReport/" + action + (accessmode != null ? accessmode : ""),
                        type: "POST",
                        data: button.data()
                    });
                }, null, { height: "80%", anchorTo: button });
            };

            var displayGradeMarkOverrideLegend = function ()
            {
                skyward.modalLayer.showDialog("Grade Mark Override Legend", function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/GetGradeMarkOverrideBrowse",
                        type: "POST"
                    });
                });
            };

            // Event handlers
            var events =
            {
                "displayGradingScaleLegend": displayGradingScaleLegend,
                "displayGradeMarkOverrideLegend": displayGradeMarkOverrideLegend
            };
            skyward.events.registerEvents("gradebookSettings", events);

            $(selector).find('.gradingPeriodBrowse').on('click', "tr input.checkbox", validateShowCheckbox);
            $(selector).find('.gradingPeriodBrowse').on('click', "tr input.SelectAllCheckBoxControl", validateShowAllCheckbox);

            $(selector).find('.gradingPeriodGradeBucketBrowse').on('click', "tr input.checkbox", validateShowCheckbox);

            $(selector).find('.gradebook_LockedAssignmentInfoButton, .gradebook_LockedGradeBucketInfoButton').off("click", showLockedAssignmentInfo).on('click', showLockedAssignmentInfo);
            $(selector).find('.gradebook_ExtensionAssignmentInfoButton, .gradebook_ExtensionGradeBucketInfoButton').off("click", showExtensionAssignmentInfo).on('click', showExtensionAssignmentInfo);
            $(selector).find('.gradebook_UnlockedAssignmentInfoButton, .gradebook_UnlockedGradeBucketInfoButton').off("click", showUnlockedAssignmentInfo).on('click', showUnlockedAssignmentInfo);

            $(selector).find('.selectAllStudentGradingScaleGroupStudentSections').on('change', selectAllStudentGradingScaleGroup);
            $(selector).find(".cloneGradebook.button").on("click", function ()
            {
                var button = $(this);
                var buttonData = button.data();
                var postData = {};
                postData["Workflow.SectionID"] = buttonData.sectionId;
                postData["Workflow.SectionID_securityhash"] = buttonData.sectionId_securityhash;
                postData["Workflow.StaffID"] = buttonData.staffId;
                postData["Workflow.StaffID_securityhash"] = buttonData.staffId_securityhash;
                postData["Workflow.EntityID"] = buttonData.entityId;
                postData["Workflow.EntityID_securityhash"] = buttonData.entityId_securityhash;
                postData["Workflow.SchoolYearID"] = buttonData.schoolYearId;
                postData["Workflow.SchoolYearID_securityhash"] = buttonData.schoolYearId_securityhash;
                postData["Workflow.RedirectURL"] = buttonData.redirectUrl;

                if (skyward.changeTracking.isDirty())
                {
                    showUnsavedDataMessage();
                }
                else
                {
                    skyward.window.loadContent("popup", "Workflow", "WorkflowInstance", "Create/Gradebook/SectionGradeBucket/CloneGradebook", null, postData);
                }
            });
        };

        var initDefaultValues = function (selector)
        {
            $(selector).find('.sectionGradeBucketContainer, .workflowEditSectionCategoriesWeighting, .workflowEditSectionGradeBucketWeighting, .gradingPeriodGradeBucketBrowse').each(function ()
            {
                var wrapper = $(this);

                wrapper.find('.weightPercent').blur(function ()
                {
                    setNullsToZero($(this));
                });

                wrapper.find('.checkbox').change(function ()
                {
                    var checkbox = $(this);
                    var checkboxId = checkbox.attr("id");
                    var browseRow = checkbox.closest('.browseRow');

                    if (checkboxId.split("-")[0] == "UseMaxExtraCredit")
                    {
                        var maxExtraCredit = browseRow.find('#MaxExtraCredit-' + checkboxId.split("-")[1]);
                        if (checkbox.is(':checked'))
                        {
                            setNullsToZero(maxExtraCredit);
                            skyward.controls.enable(maxExtraCredit);

                            if (checkbox.prop('disabled'))
                            {
                                skyward.controls.disable(maxExtraCredit);
                            }
                        }
                        else
                        {
                            skyward.controls.setValue(maxExtraCredit, '');
                            skyward.controls.disable(maxExtraCredit);
                        }
                    }
                    else
                    {
                        var weightPercent = browseRow.find('.weightPercent');
                        if (checkbox.is(':checked'))
                        {
                            setNullsToZero(weightPercent);
                        }
                        else
                        {
                            skyward.controls.setValue(weightPercent, '');
                        }
                    }
                });

                wrapper.find('.checkbox').change();

                function setNullsToZero(element)
                {
                    if (element.val() == '')
                    {
                        skyward.controls.setValue(element, '0.00');
                    }
                }
            });
        };

        var validateShowCheckbox = function ()
        {
            var input = $(this);
            var inputId = input.attr("id");
            var inputChecked = input.is(":checked");
            var row = input.closest("tr");

            switch (inputId.split("-")[0].toLowerCase())
            {
                case "showassignments":
                    if (inputChecked)   //if checked, check the Show Grade Buckets checkbox for the same grading period
                    {
                        skyward.controls.setValue(row.find('#ShowGradeBuckets-' + inputId.split("-")[1]), inputChecked);
                    }
                    break;
                case "showgradebuckets":
                    if (!inputChecked)  //if unchecked, uncheck the Show Assignments/Academic Standards/Subjects checkboxes for the same grading period
                    {
                        skyward.controls.setValue(row.find('#ShowAssignments-' + inputId.split("-")[1]), inputChecked);
                        skyward.controls.setValue(row.find('#ShowSubjects-' + inputId.split("-")[1]), inputChecked);
                        skyward.controls.setValue(row.find('#ShowAcademicStandards-' + inputId.split("-")[1]), inputChecked);
                    }
                    break;
                case "usemaxextracredit":
                    var maxExtraCreditTextBox = row.find('#MaxExtraCredit-' + inputId.split("-")[1]);
                    if (inputChecked)   //if checked, enable the Max Extra Credit textbox for the same grading period grade bucket
                    {
                        skyward.controls.enable(maxExtraCreditTextBox);
                        skyward.controls.setValue(maxExtraCreditTextBox, '0.00');
                    }
                    else //else disable
                    {
                        skyward.controls.disable(maxExtraCreditTextBox);
                        skyward.controls.setValue(maxExtraCreditTextBox, '');
                    }
                    break;
            }
        };

        var validateShowAllCheckbox = function ()
        {
            var input = $(this);
            var inputId = input.attr("id");
            var inputChecked = input.is(":checked");
            var browse = $("#editGradesheetDisplaySettings_GradeBucketsAssignmentsToDisplay");
            var checkboxes;

            switch (inputId.split("_")[0].toLowerCase())
            {
                case "showassignments":
                    if (inputChecked)   //if checked, check the Show Grade Buckets checkboxes for all the grading periods
                    {
                        checkboxes = browse.find("tr input.selectAllShowGradeBuckets:not([disabled])");
                        checkboxes.each(function ()
                        {
                            var checkbox = $(this);
                            if (checkbox.attr("id").split("-")[0].toLowerCase() == "showgradebuckets")
                            {
                                skyward.controls.setValue(checkbox, true);
                            }
                        });
                    }
                    break;
                case "showgradebuckets":
                    if (!inputChecked)
                    {
                        checkboxes = browse.find("tr input.selectAllShowAssignments:not([disabled])");
                        checkboxes.each(function ()
                        {
                            var checkbox = $(this);
                            if (checkbox.attr("id").split("-")[0].toLowerCase() == "showassignments")
                            {
                                skyward.controls.setValue(checkbox, false);
                            }
                        });
                    }
                    break;
            }
        };

        var changeCalculationType = function (calcTypeElement, controller, sectionLengthsToShow)
        {
            var isTeacherSide = (controller.indexOf("SectionGradeBucket") > -1) ? true : false;

            var dov = calcTypeElement.parents(".dataObjectViewer");

            var value = skyward.controls.getValue(calcTypeElement);

            var categoriesBrowseElement = hideSettingsBrowse(dov.find(".browse.categoriesBrowse"));
            var gradeWeightsBrowseElement = hideSettingsBrowse(dov.find(".browse.gradeBucketWeightsBrowse"), sectionLengthsToShow);
            var subjectWeightsBrowseElement = hideSettingsBrowse(dov.find(".browse.subjectWeightingBrowse"));
            var academicStandardWeightsBrowseElement = hideSettingsBrowse(dov.find(".browse.academicStandardWeightingBrowse"));
            var cumulativeAssignmentScoreExamGradeWeightsBrowseElement = hideSettingsBrowse(dov.find(".browse.cumulativeAssignmentScoresExamWeightingBrowse"));

            var browseToShow;

            if (value == "A" || value == "C" || value == "S" || value == "N" || value == "E" || value == "V")
            {
                if (isTeacherSide || value == "C")
                {
                    browseToShow = categoriesBrowseElement;
                }
            }
            else if (isGradeWeighted(value))
            {
                browseToShow = gradeWeightsBrowseElement;
            }
            else if (value == "B")
            {
                browseToShow = subjectWeightsBrowseElement;
            }
            else if (value == "D")
            {
                browseToShow = academicStandardWeightsBrowseElement;
            }
            else if (value == "U")
            {
                browseToShow = cumulativeAssignmentScoreExamGradeWeightsBrowseElement;
            }

            if (browseToShow && browseToShow.length)
            {
                showSettingsBrowse(browseToShow);
                var browseToReload = browseToShow.attr("id");
                var browseData = {};

                skyward.browse.get(browseToReload, browseData, { "calculationTypeCode": value });
                if (value == "U")
                {
                    initCumulativeWeightingBrowse.apply(browseToReload);
                }

            }
            else if (isTeacherSide || (isWeightedType(value))) //No browse for total points/subjective/not graded admin side
            {
                buildBrowseForElement(controller, value, calcTypeElement, dov, sectionLengthsToShow);
            }
        };

        var isWeightedType = function (calculationTypeCode)
        {
            return calculationTypeCode == 'T' || calculationTypeCode == 'G' || calculationTypeCode == 'C' || calculationTypeCode == 'B' || calculationTypeCode == 'D' || calculationTypeCode == 'U';
        }

        var isGradeWeighted = function (calculationTypeCode)
        {
            if (calculationTypeCode == 'T' || calculationTypeCode == 'G')
            {
                return true;
            }
            return false;
        }

        var hideSettingsBrowse = function (browse, sectionLengthsToShow)
        {
            if (browse)
            {
                if (sectionLengthsToShow != null)
                {
                    browse.remove();
                    return null;
                }
                else if (!browse.hasClass("browse--displayNone"))
                {
                    browse.addClass("browse--displayNone");
                }
            }
            return browse;
        };

        var buildBrowseForElement = function (controller, calculationType, calcTypeElement, dov, sectionLengthsToShow)
        {
            var renderInDetailsPanel = calcTypeElement.parents(".detailsPanel").length > 0;
            var calculationGroupGradeBucketID = skyward.controls.getValue(dov.find(".calculationGroupGradeBucketIDHidden"));
            var sectionGradeBucketID = skyward.controls.getValue(dov.find(".sectionGradeBucketIDHidden"));
            var isAdminDetails = skyward.controls.getValue(dov.find(".isAdminDetails"));
            var isTeacherTracker = skyward.controls.getValue(dov.find(".isTeacherTracker"));
            return buildBrowse(controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, $(this).parents('.workflow').length > 0, sectionLengthsToShow, dov);
        };

        var buildBrowse = function (controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, isCalcSetupWorkflow, sectionLengthsToShow, locationToAppendBrowse)
        {
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/" + controller + "/BuildCalculationTypeBrowse",
                type: "POST",
                dataType: "viewpartHtml",
                data:
                {
                    calculationTypeCode: calculationType,
                    calculationGroupGradeBucketID: calculationGroupGradeBucketID,
                    sectionGradeBucketID: sectionGradeBucketID,
                    renderInDetailsPanel: renderInDetailsPanel,
                    isAdminDetails: isAdminDetails,
                    isTeacherTracker: isTeacherTracker,
                    isCalcSetupWorkflow: isCalcSetupWorkflow,
                    sectionLengthsToShow: JSON.stringify(sectionLengthsToShow)
                },
                success: function (returnData)
                {
                    locationToAppendBrowse.append(returnData);
                    skyward.window.notifyDOMLoad("#" + locationToAppendBrowse.attr("id"));
                }
            });
        };

        var showSettingsBrowse = function (browse)
        {
            if (browse && browse.hasClass("browse--displayNone"))
            {
                browse.removeClass("browse--displayNone");
            }
        };

        var refreshSettingsBrowse = function (browse, controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, isCalcSetupWorkflow, sectionLengthsToShow)
        {
            var locationToAppendBrowse = browse.parent();
            hideSettingsBrowse(browse, sectionLengthsToShow);
            buildBrowse(controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, isCalcSetupWorkflow, sectionLengthsToShow, locationToAppendBrowse);
        }

        var selectAllStudentGradingScaleGroup = function ()
        {
            var input = $(this);
            var row = input.closest("tr");
            skyward.controls.setValue(row.find('.valuecheckbox:not([disabled])').not(".selectAllStudentGradingScaleGroupStudentSections"), input.is(":checked"));
        };

        var overrideCheckLoadContent = function (selector)
        {
            // On the SettingsGradingSectionScaleGroupGradeMarks screen, we want to first do a dirty check
            // since the workflow is modifying the same data as the details
            if ($(selector).find("#SettingsGradingSectionScaleGroupGradeMarks").length)
            {
                var defaultCheckLoadContent = skyward.window.checkLoadContent;

                skyward.window.checkLoadContent = function ()
                {
                    var parameters = arguments;

                    skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
                    {
                        if (wasDirty)
                        {
                            skyward.window.skipUnloadCheck = true;
                        }
                        defaultCheckLoadContent.apply(null, parameters);
                    });
                };
            }

            var selectAllStudentGradingScaleGroupStudentSectionsCheckBoxes = $(selector).find(".selectAllStudentGradingScaleGroupStudentSections");

            selectAllStudentGradingScaleGroupStudentSectionsCheckBoxes.each(function ()
            {
                var checkbox = $(this);
                var row = checkbox.closest("tr");
                if (row.find('.valuecheckbox:not([disabled])').not(".selectAllStudentGradingScaleGroupStudentSections").length == 0)
                {
                    checkbox.attr("disabled", true);
                }
            });
        };

        var showLockedAssignmentInfo = function (e)
        {
            var button = $(this);
            var data = button.data();

            if (!data || !data.gradingPeriodStartDate || !data.gradingPeriodEndDate || !data.gradeBucketLabel)
            {
                return;
            }

            var options =
            {
                anchorTo: button
            };
            skyward.modalLayer.showInformationDialog(data.gradeBucketLabel + " Closed", "<span>" + data.gradeBucketLabel + " is now <span class='boldFont'>closed</span> (" + data.gradingPeriodStartDate + " - " + data.gradingPeriodEndDate + ")</span>", null, options);
            e.stopPropagation();
        };

        var showExtensionAssignmentInfo = function (e)
        {
            var button = $(this);
            var data = button.data();

            if (!data || !data.gradingPeriodStartDate || !data.gradingPeriodEndDate || !data.gradingPeriodExtensionDays || !data.gradeBucketLabel || !data.extendedEndDate)
            {
                return;
            }

            var options =
            {
                anchorTo: button
            };

            var message = "<div class='gradebookInformationPopup'>";

            message += "<div class='sectionHeader'><h3 class='sectionHeader__text'>Extension Information</h3></div>"
                + "<div><span>" + data.gradeBucketLabel + " is now <span class='boldFont'>closed</span> ("
                + data.gradingPeriodStartDate + " - " + data.gradingPeriodEndDate
                + ") </span></div> <div> Posting for " + data.gradeBucketLabel + " has been extended "
                + data.gradingPeriodExtensionDays + " days until " + data.extendedEndDate + (data.extensionEndTime && data.extensionEndTime.toString().length > 0 ? " at " + data.extensionEndTime : "") + " </div>";

            if (data.useSnapshotGrade && data.useSnapshotGrade.toString().toLowerCase() == "true" && data.snapshotGradeExtendedEndDate)
            {
                message += "<div class='sectionHeader'><h3 class='sectionHeader__text'>Snapshot Grade Information</h3></div>"
                    + "<div><span>" + data.gradeBucketLabel + " has a <span class='boldFont'>snapshot</span> grade</span></div> "
                    + "<div> Snapshot grade for " + data.gradeBucketLabel + (data.isPastTense.toLowerCase() == "true" ? " was" : " will be") + " taken on " + data.snapshotGradeExtendedEndDate + "</div>";
            }
            message += "</div>";

            skyward.modalLayer.showInformationDialog(data.gradeBucketLabel + " Additional Information", message, null, options);
            e.stopPropagation();
        };

        var showUnlockedAssignmentInfo = function (e)
        {
            var button = $(this);
            var data = button.data();

            if (!data || !data.gradeBucketLabel)
            {
                return;
            }

            var options =
            {
                anchorTo: button
            };

            var message = "<div class='gradebookInformationPopup'>";

            message += "<div class='sectionHeader'><h3 class='sectionHeader__text'>Unlocked Information</h3></div>"
                + "<div>" + data.gradeBucketLabel + " is now <span class='boldFont'>unlocked</span> for a closed grading period grade change</div>";
            message += "</div>";

            skyward.modalLayer.showInformationDialog(data.gradeBucketLabel + " Additional Information", message, null, options);
            e.stopPropagation();
        };

        var showUnsavedDataMessage = function (onSaveAndContinue)
        {
            var warningMessage = skyward.modalLayer.showDialog(
                "Unsaved Changes",
                'You have unsaved changes on the screen.',
                [{
                    text: "Save & Continue",
                    "icon": "Save",
                    "click": function ()
                    {
                        var dovId = "editSectionGradeBuckets";
                        var dov = $("#" + dovId);
                        var saveButton = $("#" + dovId + "_save");
                        saveButton.click();
                        warningMessage.close(false);

                        if (onSaveAndContinue && typeof (onSaveAndContinue) === "function")
                        {
                            dov.on("DOVSaveComplete", onSaveAndContinue);
                        }
                    }
                },
                {
                    text: "Cancel",
                    "icon": "Cancel",
                    "click": function ()
                    {
                        warningMessage.close(false);
                    }
                }]
            );
        };

        var reloadTemplates = function (dov)
        {
            dov.find(".ajaxRepeaterPlaceHolder").each(function ()
            {
                skyward.ajaxrepeater.load($(this));
            });
        };

        var reorderClassRoster = function ()
        {
            var action = 'TeacherSectionStudentSectionSettingSortable';
            reorderClassRosterShared(action, $(this));
        };

        var reorderClassRosterTeacherTracker = function ()
        {
            var action = 'TeacherSectionStudentSectionSettingSortableTeacherTracker';
            reorderClassRosterShared(action, $(this));
        };

        var reorderClassRosterClassGroup = function ()
        {
            var action = 'TeacherSectionStudentSectionSettingClassGroupSortable';
            reorderClassRosterShared(action, $(this));
        };

        var reorderClassRosterShared = function (action, button)
        {
            var data = button.data();

            var options =
            {
                TeacherSectionSettingID: data.teachersectionsettingid,
                TeacherSectionSettingIDHash: data.teachersectionsettingidhash,
                SortableID: data.sortableid,
                SortableID_SecurityHash: data.sortableidhash
            };
            var sortablePopupFunction = function ()
            {
                skyward.window.loadContent("sortable", "Gradebook", "TeacherSectionStudentSectionSetting", action, null, options);
            };
            skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
            {
                //they clicked the button to continue anyway, so display the popup and let Mr(s). Teacher deal with the consequences
                sortablePopupFunction();
            });
        };

        var updateAcademicStandardsToDisplay = function ()
        {
            var checkbox = $(this);
            var td = checkbox.parents("td").first();
            var browse = td.parents(".editablebrowse").first();

            var uncheckChildren = function (calculationGroupAcademicStandardID)
            {
                browse.find("td.browseDataCell[data-calculation-group-academic-standard-id-parent='" + calculationGroupAcademicStandardID + "']").each(function ()
                {
                    var childTD = $(this);
                    var childData = childTD.data();
                    var childCheckbox = childTD.find(".checkbox");

                    skyward.controls.setValue(childCheckbox, false);
                });
            };

            var checkParents = function (calculationGroupAcademicStandardIDParent)
            {
                browse.find("td.browseDataCell[data-calculation-group-academic-standard-id='" + calculationGroupAcademicStandardIDParent + "']").each(function ()
                {
                    var parentTD = $(this);
                    var parentData = parentTD.data();
                    var parentCheckbox = parentTD.find(".checkbox");

                    skyward.controls.setValue(parentCheckbox, true);
                });
            };


            var data = td.data();

            if (checkbox.is(":checked"))
            {
                //make sure parent is checked
                checkParents(data.calculationGroupAcademicStandardIdParent);
            }
            else
            {
                uncheckChildren(data.calculationGroupAcademicStandardId);
            }
        };
        var initCumulativeWeightingBrowse = function ()
        {
            var browse = $(this);

            browse.find("input.cumulativeGradeWeightingPercent").each(function ()
            {
                var input = $(this);
                if (input.data() && input.data().typeCode == "CU")
                {
                    skyward.controls.disable(input);
                }
            });
            updateCumulativeAssignmentScoreWeightings(browse);
        };

        var updateCumulativeAssignmentScoreWeightings = function (browse)
        {
            var sum = 0;
            browse.find("input.cumulativeGradeWeightingPercent[data-type-code!='CU']").each(function ()
            {
                var input = $(this);
                if (input.data() && input.data().typeCode != "CU")
                {
                    var value = parseFloat(skyward.controls.getValue(input));

                    if (value && value != null)
                    {
                        sum = parseFloat(sum) + value;
                    }
                }
            });

            var cumulativeLeftOverPercent = (100 - sum).toFixed(2);
            if (cumulativeLeftOverPercent < 0)
            {
                cumulativeLeftOverPercent = 0.00;
            }
            var cumulativeWeightField = browse.find("input.cumulativeGradeWeightingPercent[data-type-code='CU']");
            skyward.controls.setValue(cumulativeWeightField, cumulativeLeftOverPercent, false);
        };

        var initTempSectionGradebookSettingsBrowse = function ()
        {
            var browse = $(this);

            var updateSettingBrowse = function ()
            {
                var currentRow = browse.find(".current");
                var settingTypeColumn = currentRow.find("td[data-setting-type]");
                var code = "";
                if (settingTypeColumn && settingTypeColumn.length > 0)
                {
                    code = settingTypeColumn.data().settingType;
                }

                var hideCalcBrowse = true;
                var hideGradingScaleBrowse = true;
                var hideStudentGradingScaleBrowse = true;
                var hideSubjectStandardErorBrowse = true;
                if (code == "GC")
                {
                    hideCalcBrowse = false;
                }
                else if (code == "GS")
                {
                    hideGradingScaleBrowse = false;
                }
                else if (code == "SS")
                {
                    hideStudentGradingScaleBrowse = false;
                }
                else if (code == "AD" || code == "SJ")
                {
                    hideSubjectStandardErorBrowse = false;
                }

                if (hideGradingScaleBrowse)
                {
                    $("#TempSectionGradingScales").hide();
                } else
                {
                    $("#TempSectionGradingScales").show();
                }

                if (hideStudentGradingScaleBrowse)
                {
                    $("#TempStudentGradingScaleGroupStudentSections").hide();
                } else
                {
                    $("#TempStudentGradingScaleGroupStudentSections").show();
                }

                if (hideCalcBrowse)
                {
                    $("#TempSectionGradeBuckets").hide();
                } else
                {
                    $("#TempSectionGradeBuckets").show();
                }

                if (hideSubjectStandardErorBrowse)
                {
                    $("#TempSectionGradebookSettingErrors").hide();
                } else
                {
                    $("#TempSectionGradebookSettingErrors").show();
                }
            };

            browse.on("rowChanged", function ()
            {
                updateSettingBrowse();
            });

            browse.on("browseLoaded." + browse.attr("id"), function () { updateSettingBrowse(); });
        }

        var initClassListStudentLookup = function ()
        {
            var tile = $(this);
            var tileData = tile.data();

            var browseName = tileData.browseNameToFilter;
            var browseElement = $("#" + browseName);
            var browse = skyward.browse.browseList[browseName];
            var browseInitialFilter = browse.data.filter;
            var browseInitialRouteHash = browse.routeHash;

            var updateBrowsePostData = function (studentIDFilter)
            {
                var browseToUpdate = $(this);

                browseToUpdate.find('.tileRedirectButton').each(function ()
                {
                    var tileButton = $(this);
                    var tileButtonData = tileButton.data();
                    if (tileButtonData.postdata)
                    {
                        tileButtonData.postdata.studentIDToSeek = studentIDFilter;
                    }
                });
                browseElement.off('browseLoaded.' + browseName, updateBrowsePostData);

            };

            var processStudentChange = function ()
            {
                var tileViewEEL = $(this);

                if (!tileViewEEL || !tileViewEEL.hasClass('tileViewEEL'))
                {
                    return;
                }

                var studentID = skyward.controls.getValue(tileViewEEL);
                var searchText = skyward.controls.getValue(tileViewEEL.find(".tileViewEEL_search"));

                if (searchText == null || searchText == "")
                {
                    studentID = null;
                }

                $.ajax(
                    {
                        url: skyward.global.virtualDir + "Gradebook/GradebookBySection/GenerateClassListFilter",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            StudentID: studentID
                        },
                        success: function (data)
                        {
                            browse.data.filter = (data.SearchCondition) ? JSON.stringify(JSON.parse(data.SearchCondition)) : browseInitialFilter;
                            browse.routeHash = (data.RouteHash) ? data.RouteHash : browseInitialRouteHash;
                            skyward.browse.get(browseName, {});
                            browseElement.on('browseLoaded.' + browseName, function () { updateBrowsePostData.apply(browseElement, [skyward.controls.getValue(tileViewEEL)]) });
                        }
                    });
            };

            var eelOptions = {
                beforeClose: function ()
                {
                    setTimeout(function ()
                    {
                        browse.keyEventsEnabled = true;
                    }, 500);
                },
                beforeOpen: function ()
                {
                    browse.keyEventsEnabled = false;
                }
            };

            skyward.tilevieweel.registerTileViewEEL(tile, null, eelOptions);

            var processStudentChangeClear = function ()
            {
                var tileViewEEL = $(this);

                var searchText = skyward.controls.getValue(tileViewEEL.find(".tileViewEEL_search"));

                if (searchText == null || searchText == "")
                {
                    processStudentChange.apply(tileViewEEL);
                }
            };

            tile.off("eelComplete", processStudentChange).on("eelComplete", processStudentChange);
            tile.off("change", processStudentChangeClear).on("change", processStudentChangeClear);
        };

        var initPreviousSectionLengths = function ()
        {
            //Dependency clearing logic for the selector eel.  The default dependency clearing logic interfered with the other logic to refresh the browse and would cause browses to duplicate, so we needed to override that here.
            $(this).on("click", function ()
            {
                var checkbox = skyward.controls.getValue($(this));
                if (checkbox == false)
                {
                    //First parent being the fieldset, second parent being the parent element of all of our inputs
                    var dmse = $(this).parents('.gradeWeightingSectionLengthSelectorDiv').last().find('div.previousSectionLengthsSelect input.dmsBackingData');
                    skyward.controls.clearValue(dmse);
                }
            });

            //This triggers when the Previous Section Lengths eel is modified and refreshes the browse with the new buckets based on the selected section lengths.
            $(this).parents('.gradeWeightingSectionLengthSelectorDiv').on("change", "div.previousSectionLengthsSelect input.dmsBackingData", function ()
            {
                //Action only triggers when section lengths are changed.  We disable section lengths on the teacher side, and in teacher tracker/section grade bucket details, so anything section-specific here is irrelevant
                //Also assume the calculation type is Grade Weighting because it has to be in order for the section lengths selector to show up
                var sectionLengthsToShow = skyward.controls.getValue($(this));
                var browse = $(this).parents('.previousSectionLengthsSelect').parents('.gradeWeightingSectionLengthSelectorDiv').parent().find('.gradeBucketWeightsBrowse');
                var controller = "CalculationGroupGradeBucket";
                var calculationType = "G";
                var renderInDetailsPanel = $(this).parents(".detailsPanel").length > 0;
                var calculationGroupGradeBucketID = skyward.controls.getValue($(this).parents('.gradeWeightingSectionLengthSelectorDiv').find('.calculationGroupGradeBucketIDHidden'));
                var sectionGradeBucketID = null;
                var isAdminDetails = false;
                var isTeacherTracker = false;
                refreshSettingsBrowse(browse, controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, $(this).parents('.workflow').length > 0, sectionLengthsToShow);
            });

            //This triggers when the calc type is changed, but only processes further than the first check if the calc type is grade weighted.  This is clearing the previous section length selected.  Really only relevant if they had previous section lengths selected when they loaded the screen, then changed the calc type to something else, then back to a grade weighted type.  Dependency logic correctly unchecks the Show Previous Section Lengths checkbox, but since the dependency logic for that checkbox only triggers on click, we need additional logic here to clear this selector as well.
            //Previous section lengths value only matters if the calc type is grade weighted, so no need to trigger this logic for other calc types.
            $("#editCalculationGroupGradeBucket").off("change", ".js-CalcTypeComboBox").on("change", ".js-CalcTypeComboBox", function ()
            {
                var selector = $(this);
                var sectionLengthsToShow = null;

                if (isGradeWeighted(skyward.controls.getValue(selector)))
                {
                    var dmse = $('#editCalculationGroupGradeBucket div.previousSectionLengthsSelect input.dmsBackingData');

                    if (dmse != null)
                    {
                        sectionLengthsToShow = skyward.controls.getValue(dmse);

                        if (sectionLengthsToShow != null && Object.keys(sectionLengthsToShow).length > 0)
                        {
                            skyward.controls.clearValue(dmse, true);
                            sectionLengthsToShow = skyward.controls.getValue(dmse);
                        }
                    }
                }

                changeCalculationType(selector, "CalculationGroupGradeBucket", sectionLengthsToShow);
            });
        };

        var events =
        {
            'ReorderClassRoster': reorderClassRoster,
            'ReorderClassRosterTeacherTracker': reorderClassRosterTeacherTracker,
            'ReorderClassRosterClassGroup': reorderClassRosterClassGroup,
            'initCumulativeWeightingBrowse': initCumulativeWeightingBrowse,
            'initTempSectionGradebookSettingsBrowse': initTempSectionGradebookSettingsBrowse,
            'initClassListStudentLookup': initClassListStudentLookup,
            'initPreviousSectionLengths': initPreviousSectionLengths
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.window.registerLoadDOMCallback(initDefaultValues);
        skyward.window.registerLoadDOMCallback(overrideCheckLoadContent);
        skyward.events.registerEvents('gradebookSettings', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
